import React, { useState, forwardRef, useImperativeHandle} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { HttpService } from '../../apiAuthorization/httpService';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    mb10: {
        marginBottom: "10px"
    },
    mb5: {
        marginBottom: "5px"
    }
}));

const ContactAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { patientSittingDto, close } = props;
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [contactDto, setContactDto] = useState({
        AppPatientSittingId: patientSittingDto.Id,
        LocationId: patientSittingDto.LocationId,
        Attendant: patientSittingDto.Attendant,
        AttendantUsername: patientSittingDto.AttendantUsername,
        LocationPath: patientSittingDto.LocationPath,
        Bed: patientSittingDto.Bed,
        Request:""
    });

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const sendContact = () => {

        if (!contactDto.Request) {
            setErrorMessage("Please enter an Request.");
            setOpenError(true);
            return;
        }

        HttpService.post('/PatientSitting/SendContact',
            contactDto
        )
            .then((result) => {
                close();
            },
                (error) => {
                      //This is intentional
                });
    };

    useImperativeHandle(ref, () => {
        return {
            save: sendContact,

        };
    });

    return (
        <div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <TextField size="small" fullWidth
                label="On-Duty Attendant"
                variant="outlined"
                disabled={true}
                className={classes.mb10}
                value={contactDto.Attendant || ""}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <TextField size="small" fullWidth
                label="Location"
                variant="outlined"
                disabled={true}
                className={classes.mb10}
                value={contactDto.LocationPath || ""}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <TextField size="small" fullWidth
                label="Bed"
                variant="outlined"
                disabled={true}
                className={classes.mb10}
                value={contactDto.Bed || ""}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <TextField size="small" fullWidth
                multiline
                rows="4"
                label="Request"
                variant="outlined"
                value={contactDto.Request || ""}
                onChange={(e) => { setContactDto({ ...contactDto, Request: e.target.value }); }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </div>
    );
});

export default ContactAdd;